import { cn } from '@repo/ui/utils'
import * as React from 'react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'border-primary-200 text-primary ring-offset-primary-600 file:text-primary-950 placeholder:text-primary-500 focus-visible:ring-primary-600 dark:border-primary-800 dark:bg-primary-950 dark:ring-offset-primary-950 dark:file:text-primary-50 dark:placeholder:text-primary-400 dark:focus-visible:ring-primary-300 focus-visible:ring-accent flex h-10 w-full rounded-md border bg-white px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
